module.exports = __webpack_public_path__ + "static/media/404.07de9c03.png";